import { z } from 'zod';
import {
  CVSS_SCORE_STATUSES,
  FINDING_CVSS_VERSIONS,
  SEVERITY_SOURCES,
} from '@terra/shared-cvss';
import { FindingCvssDataSchema } from './finding-create.schema';

const FindingCvss40DataSchema = FindingCvssDataSchema.refine(
  (cvss) => cvss.version === '4.0',
  { message: 'cvss40 must use CVSS version 4.0' },
);

const FindingCvss31DataSchema = FindingCvssDataSchema.refine(
  (cvss) => cvss.version === '3.1',
  { message: 'cvss31 must use CVSS version 3.1' },
);

export const FindingCvssVersionUpdateFieldsSchema = z.object({
  cvss40: FindingCvss40DataSchema.optional(),
  cvss31: FindingCvss31DataSchema.optional(),
  severityReason: z.string().optional(),
});

export const FindingCvssVersionFieldsSchema = z.object({
  cvss40: FindingCvss40DataSchema.nullable().optional(),
  cvss31: FindingCvss31DataSchema.nullable().optional(),
  cvssVersion: z.enum(FINDING_CVSS_VERSIONS).nullable().optional(),
  cvssScoreStatus: z.enum(CVSS_SCORE_STATUSES).nullable().optional(),
  cvssScoreRequestedAt: z.coerce.date().nullable().optional(),
  severitySource: z.enum(SEVERITY_SOURCES).nullable().optional(),
});
